export const API_URL = 'users'
export const ROUTE_NAME = 'users'
